<div
  id="tripNotesDetail-{{ testingIdAccessor }}-list-notes"
  *ngIf="customerServiceNotes && customerServiceNotes.length > 0; else noNotes"
  class="note-area"
  #noteScrollArea
  [scrollTop]="scrollHeight"
  appInfiniteScroller
  scrollPerecnt="50"
  (scrolled)="onScroll()"
>
  <div class="note-row" *ngFor="let note of customerServiceNotes" data-private>
    <div class="note">
      <mat-card appearance="outlined">
        <mat-card-content id="tripNotesDetail-{{ testingIdAccessor }}-noteCard-{{ note.id }}">
          <p class="header">{{ note.createdBy }} {{ note.createdAt | date : 'short' }}</p>
          <p id="tripNotesDetail-{{ testingIdAccessor }}-note-{{ note.id }}" class="content">{{ note.text }}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<ng-template #noNotes>
  <div class="note-area no-notes">
    <mat-icon>drafts</mat-icon>
    <p>No notes</p>
  </div>
</ng-template>

<ng-container *appRequiresPermissions="{ any: ['customer_service_note_create'], all: [] }">
  <form (ngSubmit)="onSubmit()" [formGroup]="newNoteForm">
    <mat-form-field appearance="outline">
      <mat-label>Note</mat-label>
      <input id="tripNotesDetail-{{ testingIdAccessor }}-input-note" matInput formControlName="text" data-private="lipsum" />
    </mat-form-field>
    <button
      id="tripNotesDetail-{{ testingIdAccessor }}-button-send"
      mat-mini-fab
      color="primary"
      [disabled]="newNoteForm.get('text').value === ''"
    >
      <mat-icon>send</mat-icon>
    </button>
  </form>
</ng-container>
